import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

/**
 * Minimal teaser nav: FRDM wordmark left, single Jobs link right.
 * Used across the site until launch. Other pages reachable by direct URL only.
 */
export const Nav = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-nav"
      className="sticky top-0 z-40 bg-navy text-bone border-b-2 border-red"
    >
      <div className="max-w-[1600px] mx-auto px-5 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-home-logo"
          className="flex items-center"
          aria-label="Freedom Coffee — Home"
        >
          <img
            src="/assets/frdm-logo.png"
            alt="FRDM"
            className="h-5 md:h-6 w-auto"
            style={{ filter: "invert(1) brightness(1.05)" }}
          />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          <Link
            to="/jobs"
            data-testid="nav-jobs-link"
            className="font-mono uppercase tracking-[0.25em] text-xs lg:text-sm text-bone hover:text-red transition-colors duration-200"
          >
            Jobs
          </Link>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
          onClick={() => setOpen((o) => !o)}
          className="md:hidden p-2 -mr-2 text-bone hover:text-red"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden bg-navy border-t border-red/40"
        >
          <div className="px-5 py-6 flex flex-col gap-5">
            <Link
              to="/jobs"
              data-testid="nav-jobs-mobile-link"
              onClick={() => setOpen(false)}
              className="font-display uppercase text-4xl leading-none tracking-tight text-bone"
            >
              Jobs
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Nav;
